<script lang="ts">
    import translate from '../../../../lib/translate'
    import Event from './ProgramTab/Event.svelte'
    import label from './ProgramTab.translation'

    async function loadEpg(label) {
        try {
            const epgUrl = globalThis.config.baseUrl+'/misc_frontend/epg'
            const response = await fetch(epgUrl, {
                method: 'GET',
                mode: 'cors'
            });
            if (!response.ok) {
                //console.log(response.statusText);
                return [{error: JSON.stringify(translate(label.errorText))}];
            } else {
                const epgData = await response.json();
                if(epgData.length === 0){
                    return [{error: JSON.stringify(translate(label.errorText))}];
                } else {
                    return epgData;
                }
            }
        } catch (e) {
            console.error(e);
            return [{error: JSON.stringify(translate(label.errorText))}];
        }
    }

</script>
<div class="epg">
    <div class="auction-box-scrollable">
        {#await loadEpg(label)}
            {translate(label.loading)}
        {:then data}
            {#each data as event }
                <Event {event} />
            {/each}
        {/await}
    </div>
</div>